// extracted by mini-css-extract-plugin
module.exports = {"dashboardContainer":"dashboard_dashboardContainer__9l9fm"};